import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import AlertProvider from './contexts/AlertContext'
import LoginPage from './components/auth/LoginPage'
import ProtectedRoute from './components/auth/ProtectedRoute'
import AppLayout from './components/layout/AppLayout'
import Dashboard from './components/tools/Dashboard'
import MovePlayerHelmetTool from './components/tools/MovePlayerHelmetTool'
import MoveHelmetOrgFlow from './components/tools/MoveHelmetOrgFlow'
import HelmetLookupTool from './components/tools/HelmetLookupTool'
import PlayerUnitSwapTool from './components/tools/PlayerUnitSwapTool'
import SupportDashboardsTool from './components/tools/SupportDashboardsTool'

const App: React.FC = () => {
  return (
    <AlertProvider>
      <AuthProvider>
        <Routes>
            <Route path='/login' element={<LoginPage />} />            <Route element={<ProtectedRoute />}>
              <Route path='/' element={<AppLayout />}>
                <Route index element={<Dashboard />} />
                <Route path='/helmet-lookup' element={<HelmetLookupTool />} />
                <Route path='/move-player-helmet' element={<MovePlayerHelmetTool />} />
                <Route path='/move-helmet-org' element={<MoveHelmetOrgFlow />} />
                <Route path='/player-unit-swap' element={<PlayerUnitSwapTool />} />
                <Route path='/support-dashboards' element={<SupportDashboardsTool />} />
              </Route>
            </Route>

            <Route path='*' element={<Navigate to='/' replace />} />
          </Routes>
      </AuthProvider>
    </AlertProvider>
  )
}

export default App
